import { Button, Form, Radio } from "antd";
import React, { useEffect } from "react";
import { Modal } from "react-bootstrap";
import ComparisonTimes from "./tabs/ComparisonTimes";
import ComparisonData from "./tabs/ComparisonData";
import dayjs from "dayjs";
import moment from "moment";
import PropTypes from "prop-types";

const onFinishFailed = (errorInfo) => {
  // eslint-disable-next-line no-console
  console.log("Failed:", errorInfo);
};

function DeviceComparisonModal({
  mode,
  show,
  setShow,
  formData,
  setFormData,
  getReport,
  setDeviceData,
  setDeviceTableData,
  setDeviceParameters,
  setPage,
}) {
  const [form] = Form.useForm();

  useEffect(() => {
    const values = { ...formData };
    if (formData?.timeRange) {
      values.timeRange = formData?.timeRange?.map((item) => dayjs(item, "YYYY-MM-DD"));
    }
    form.setFieldsValue(values);
  }, [show]);

  const handleClose = () => {
    setShow((pre) => !pre);
  };

  const handleReset = () => {
    handleClose();
    setFormData({ type: "graph" });
    setDeviceData([]);
    setDeviceTableData([]);
    setDeviceParameters([]);
    form.resetFields();
  };

  const onFinish = (values) => {
    setPage(1);
    getReport(values.type || "graph");
    setShow(false);
  };

  return (
    <div>
      <Modal show={show} onHide={handleClose} centered backdropClassName="modal-bg-1">
        {/* header */}
        <Modal.Header closeButton>
          {" "}
          {mode === "bulk" ? "Download Bulk Data" : "Generate Device Comparison Report"}
        </Modal.Header>

        {/* body */}
        <Modal.Body className="p-3">
          <Form
            name="createDashboard"
            form={form}
            onFinish={onFinish}
            onFinishFailed={onFinishFailed}
            autoComplete="off"
            layout="vertical"
            initialValues={{ type: "graph", ...formData, timeRange: undefined }}
            onValuesChange={(_, values) => {
              const interval = (values?.intervalTime || 0) * (values?.intervalValue || 1);
              const modified = { ...values, interval };
              if (values?.timeRange?.length) {
                modified.timeRange =
                  values?.timeRange?.map((time) => moment(new Date(time)).format("YYYY-MM-DD")) || [];
              }

              return setFormData((pre) => ({ ...pre, ...modified }));
            }}
          >
            {mode === "generate" ? (
              <Form.Item label="Report Type" name="type" rules={[{ required: true, message: "Select Report Type" }]}>
                <Radio.Group className="d-flex">
                  <Radio.Button
                    className="w-100 fw-bold d-flex align-items-center justify-content-center"
                    style={{ height: "80px" }}
                    value="graph"
                  >
                    Graph
                  </Radio.Button>
                  <Radio.Button
                    className="w-100 fw-bold d-flex align-items-center justify-content-center"
                    style={{ height: "80px" }}
                    value="table"
                  >
                    Table
                  </Radio.Button>
                </Radio.Group>
              </Form.Item>
            ) : (
              ""
            )}
            {/* data component */}
            <ComparisonData {...{ form, formData, setFormData }} />
            {/* time component */}
            <ComparisonTimes {...{ form, formData }} />

            <div className="d-flex align-items-center justify-content-end gap-2">
              <Button type="primary" htmlType="submit">
                {mode === "bulk" ? "Download" : "Generate"}
              </Button>
              <Button type="primary" danger onClick={handleReset} htmlType="button">
                Reset
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default DeviceComparisonModal;

DeviceComparisonModal.propTypes = {
  mode: PropTypes.string,
  show: PropTypes.bool,
  setShow: PropTypes.func,
  formData: PropTypes.object,
  setFormData: PropTypes.func,
  getReport: PropTypes.func,
  setDeviceData: PropTypes.func,
  setDeviceTableData: PropTypes.func,
  setDeviceParameters: PropTypes.func,
  setPage: PropTypes.func,
};
